import classnames from 'classnames';
// import BbWhitelabelBlock from 'components-new/eCommerce/BottomBar/BbWhitelabelBlock';
import _ from 'lodash';
import { memo, useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import { GameCondition } from '../../../../_models/Game';
import { Tag, TagType } from '../../../../_models/Tag';
import { PolygonAction, PolygonActionMode } from '../../../../_models/virtualStaging/Polygon';
import DeviceManager from '../../../util/deviceManager';
import ReelVideoBar from '../../regular/bottomBar/ReelVideoBar';
import { BackpackReel } from './components';
import {
  transformCollectItemsToBackpackItem,
  transformConditionToBackpackItem,
  transformPolygonToBackpackItem,
  transformTagToBackpackItem,
} from './components/BackpackReel/service';
import { BackpackItem, BackpackItemType } from './components/BackpackReel/types';
import { BottomBarProps } from './types';
import { bottomBarOpenState } from '../../../../store';

const MReelVideoBar = memo(ReelVideoBar);

export default function BottomBar({
  clickOnTagBackpack,
  isFull,
  clickOnPolygonBackpack,
  clickOnConditionBackpack,
  onToggleBackpackModal,
  tags,
  polygons,
  conditions,
  collectItems,
  tourId,
  tour,
  changeFull,
  showBackpack,
  showBackpackByDefault,
  gameHasStarted,
  setBackpackNewItems,
  host,
  reelVideos,
  onMuteClick,
  onFullscreenClick,
  onPinClick,
  audioOnly,
  showParticipantsReel,
}: // translation,
// whiteLabelData,
// onHelpClick,
BottomBarProps) {
  const [backpacks, setBackpacks] = useState<BackpackItem[]>();
  const hasVideos = Boolean(reelVideos?.length);
  const [isBbOpen, setIsBbOpen] = useRecoilState(bottomBarOpenState);

  const openBackpackItem = (item, type) => {
    if (type === BackpackItemType.Tag) {
      clickOnTagBackpack(item as Tag);
    } else if (type === BackpackItemType.Polygon) {
      clickOnPolygonBackpack(item as PolygonAction);
    } else if (type === BackpackItemType.Condition) {
      clickOnConditionBackpack(item as GameCondition);
    }
  };

  useEffect(() => {
    if (showBackpackByDefault && !showBackpack && gameHasStarted) {
      onToggleBackpackModal();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gameHasStarted]);

  // clear new items on open backpack
  useEffect(() => {
    if (showBackpack && setBackpackNewItems) {
      setBackpackNewItems(0);
    }
  }, [showBackpack, setBackpackNewItems]);

  useEffect(() => {
    setIsBbOpen(showBackpack || showParticipantsReel || false);
  }, [setIsBbOpen, showBackpack, showParticipantsReel]);

  useEffect(() => {
    setBackpacks((prevState: BackpackItem[]) => {
      const transformedData = _.chain(tags)
        .filter(
          (t) =>
            (t.type === TagType.Popup || t.type === TagType.Music || t.type === TagType.Iframe) &&
            t.gameBackpack,
        )
        .map((t) => transformTagToBackpackItem(t, tourId))
        .value();

      const updatedBackpacks = _.chain(prevState || [])
        .reject({ type: BackpackItemType.Tag })
        .value();
      return [...transformedData, ...updatedBackpacks];
    });
  }, [tags, tourId]);
  useEffect(() => {
    setBackpacks((prevState: BackpackItem[]) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const transformedData = _.chain(polygons)
        .filter((polygon: any) => {
          const actions = polygon.polygonsActions?.filter(
            ({ mode }) => mode === PolygonActionMode.VS,
          );
          return actions?.find((i) => i.gameBackpack);
        })
        .map((p) => transformPolygonToBackpackItem(p, tourId))
        .value();

      const updatedBackpacks = _.chain(prevState || [])
        .reject({ type: BackpackItemType.Polygon })
        .value();
      return [...transformedData, ...updatedBackpacks];
    });
  }, [polygons, tourId]);
  useEffect(() => {
    setBackpacks((prevState: BackpackItem[]) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const transformedData = _.chain(conditions)
        .filter((condition) => condition.gameBackpack)
        .map((c) => transformConditionToBackpackItem(c, c.gameId, c.id))
        .value();

      const updatedBackpacks = _.chain(prevState || [])
        .reject({ type: BackpackItemType.Condition })
        .value();
      return [...transformedData, ...updatedBackpacks];
    });
  }, [conditions]);
  useEffect(() => {
    setBackpacks((prevState: BackpackItem[]) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const transformedData = _.chain(collectItems)
        .groupBy('id')
        .map((group) => ({ ...group[0], count: group.length }))
        .map((c) => transformCollectItemsToBackpackItem(c, tour.gameId))
        .value();

      const updatedBackpacks = _.chain(prevState || [])
        .reject({ type: BackpackItemType.CollectItem })
        .value();
      return [...transformedData, ...updatedBackpacks];
    });
  }, [collectItems, tour]);

  const isMobile = DeviceManager.isMobile();
  return (
    <div
      id="bottom-bar"
      className={classnames('game-bottom-bar', isBbOpen && 'open', isMobile && 'mobile')}
    >
      <div className="action-icon full-screen-icon" onClick={() => changeFull()}>
        <i className={isFull ? 'fas fa-compress' : 'fas fa-expand'} />
      </div>
      {tour.matterId === 'SSfUe8iZLK1' && (
        <a
          href="https://treedis.com"
          rel="noreferrer"
          target="_blank"
          style={{
            position: 'absolute',
            bottom: '4px',
            left: '10px',
            zIndex: 1000,
          }}
        >
          <img
            style={{ height: '23px' }}
            className="treedis-logo"
            src="/images/logo-black.svg"
            alt="treedis"
          />
        </a>
      )}
      {tour.matterId === 'SSfUe8iZLK1' && (
        <a
          href="https://matterport.com"
          rel="noreferrer"
          target="_blank"
          style={{
            position: 'absolute',
            bottom: '10px',
            left: '90px',
            zIndex: 1000,
          }}
        >
          <img className="mp-logo" src="/images/matterport.svg" alt="matterport" />
        </a>
      )}
      <BackpackReel
        show={showBackpack}
        items={backpacks}
        openItem={openBackpackItem}
        onToggleBackpackModal={onToggleBackpackModal}
      />
      {showParticipantsReel && (
        <MReelVideoBar
          show={showParticipantsReel && hasVideos}
          host={host}
          videos={reelVideos}
          onMuteClick={onMuteClick}
          onFullscreenClick={onFullscreenClick}
          onPinClick={onPinClick}
          audioOnly={audioOnly}
        />
      )}
      {/* <BbWhitelabelBlock translation={translation} whiteLabel={whiteLabelData} tour={tour} onHelpClick={onHelpClick} /> */}
    </div>
  );
}
